/**
 * Minimal layout for "popup-style" routes opened in a new tab from
 * elsewhere in the app (e.g. the table-output viewer).
 *
 * Keeps the CAPCO classification banners — they're compliance-required on
 * every page — but drops the navbar so the viewer fills the whole tab.
 * The Outlet sits between the two banners and adjusts its padding so the
 * page content isn't covered by the fixed banners.
 */
import { Outlet } from 'react-router';
import { ClassificationBanner } from '@brew/ui';
import { useAppInfo } from '@/app/useAppInfo';
import { appChrome, appChromeStyle } from './appChrome';

export default function StandaloneLayout() {
  const { info } = useAppInfo();
  const capcoEnabled = info?.capco?.enabled;
  const chrome = appChrome({ navbar: false, capco: !!capcoEnabled });

  return (
    <div className="min-h-screen" style={appChromeStyle(chrome)}>
      <div className="capco-banner">
        <ClassificationBanner
          position="top"
          enabled={!!capcoEnabled}
          backgroundColor={info?.capco?.['background-color']}
          color={info?.capco?.color}
          label={info?.capco?.text}
        />
      </div>
      <main
        className="w-full overflow-auto"
        style={{
          paddingTop: chrome.top,
          paddingBottom: chrome.bottom,
          minHeight: `calc(100vh - ${chrome.bottom}px)`,
        }}
      >
        <Outlet />
      </main>
      <div className="capco-banner">
        <ClassificationBanner
          position="bottom"
          enabled={!!capcoEnabled}
          backgroundColor={info?.capco?.['background-color']}
          color={info?.capco?.color}
          label={info?.capco?.text}
        />
      </div>
    </div>
  );
}
